import React, { useState, useEffect } from 'react';
import type { IProps } from './plans-section-container';
import { getInboxRadarPlanData } from './utils/helper';
import { getPlanMode } from '../../../select-plan/utils/helper';
import { isRequestPending } from '../../../../utils/helper';
import InboxRadarPlanCard from '../inbox-radar-plan-card';

const PlansSection: React.FC<IProps> = ({
  planCycle,
  onSelectPlan,
  selectedPlanId,
  //* API Request State
  sendGetInboxAnalyzerPlansResponse,
  sendGetInboxAnalyzerSubscriptionResponse,
  sendPurchaseInboxAnalyzerSubscriptionRequestStatus,
  sendGetPurchaseInboxAnalyzerModifySubscriptionRequestStatus,
  isDemoAccount,
  isPaddlePolling,
}) => {
  const isPurchaseInProgress =
    isRequestPending(sendPurchaseInboxAnalyzerSubscriptionRequestStatus) ||
    isRequestPending(
      sendGetPurchaseInboxAnalyzerModifySubscriptionRequestStatus,
    );

  //* states
  const [planData, setPlanData] = useState([]);
  const [customScalePlusPlans, setCustomScalePlusPlans] = useState([]);

  //* useEffect
  useEffect(() => {
    if (sendGetInboxAnalyzerPlansResponse) {
      setPlanData([
        ...getInboxRadarPlanData(
          getPlanMode(planCycle),
          sendGetInboxAnalyzerPlansResponse,
        ),
        // {
        //   ...(planCycle === BillingOption.MONTHLY
        //     ? customPlanScale100kMonthly
        //     : customPlanScale100kYearly),
        // },
      ]);
      // setCustomScalePlusPlans([
      //   ...getCustomScalePlusPlanData(
      //     getPlanMode(planCycle),
      //     sendGetPlansResponse,
      //   ),
      // ]);
    }
  }, [
    planCycle,
    sendGetInboxAnalyzerPlansResponse,
    sendGetInboxAnalyzerSubscriptionResponse,
  ]);

  return (
    <div className="d-flex justify-content-between align-items-end inbox-radar-plans-card-container mt-4">
      {planData?.map((plan) => (
        <InboxRadarPlanCard
          key={plan?.id}
          plan={plan}
          customScalePlusPlans={customScalePlusPlans}
          planCycle={planCycle}
          handlePlanSelect={(planId, planName) =>
            onSelectPlan(planId, planName)
          }
          sendGetInboxAnalyzerSubscriptionResponse={
            sendGetInboxAnalyzerSubscriptionResponse
          }
          sendGetInboxAnalyzerPlansResponse={sendGetInboxAnalyzerPlansResponse}
          isPurchaseInProgress={
            (isPurchaseInProgress && selectedPlanId === plan?.id) || isPaddlePolling
          }
          isDemoAccount={isDemoAccount}
        />
      ))}
    </div>
  );
};

export default PlansSection;
